import React, { useState } from 'react';
import JSDisplayWidgetCollapsibleReplicaBtn from './JSDisplayWidgetCollapsibleReplicaBtn';

const JSDisplayWidgetCollapsibleHeight = (props) => {
  let initialOpened = true;
  if (props.initialOpened === true) {
    initialOpened = true;
  }
  if (props.initialCollapsed === true) {
    initialOpened = false;
  }
  const [opened, setOpened] = useState(initialOpened);
  const _handleClick = (e) => {
    if (opened) {
      setOpened(false);
    } else {
      setOpened(true);
    }
  };
  let cl_opened = ' js-widget-collapsible-h--closed';
  /*
  let jsxBtn = (
    <i className="fa fa-plus-square-o" aria-hidden="true"></i>
  );
  */
  if (opened) {
    cl_opened = ' js-widget-collapsible-h--opened';
    /*
    jsxBtn = (
      <i className="fa fa-minus-square-o" aria-hidden="true"></i>
    );
    */
  }
  return (
    <div className={"js-widget-collapsible-h " + cl_opened}>
      <JSDisplayWidgetCollapsibleReplicaBtn collapsed={!opened} handleClick={_handleClick} />
      <div className="js-widget-collapsible-h__h-original-col">{props.children}</div>
    </div>
  );
};

export default JSDisplayWidgetCollapsibleHeight;